import SectionTitle from '@/components/base/SectionTitle';
import { steps } from '@/mocks/site';

export default function StepsSection() {
  return (
    <section id="process" className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="Verification Flow"
          title="一条爆料，要过四道关"
          desc="求证不是凭感觉下判断，而是一套可以重复的执行流程。每一步都会留下记录，方便你回头看我们是怎么得出结论的。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((item) => (
            <article
              key={item.step}
              className="group relative flex flex-col rounded-xl border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-accent-300 hover:bg-background-100"
            >
              <span className="font-heading text-3xl font-black text-background-400 transition-colors group-hover:text-accent-400">
                {item.step}
              </span>
              <span className="mt-3 flex h-11 w-11 items-center justify-center rounded-lg bg-background-50 text-accent-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}